export default {"src":"/_next/static/media/quicktime.f6cd9bb7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};